'use strict';

module.exports = [function () {
        
        return {
        template: require('./csvExport.html'),
//        controller: require('./csvExportCtrl'),
//        controllerAs: 'CSVCtrl',
        restrict: 'E',
        scope: {
            fieldSeparator: "="
            , filename: "="
            , getCsvHeader: "&"
            , getCsvData: "&"
        }
    };
    }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/csvExport/csvExport.js
// module id = 273
// module chunks = 0